// Image skeleton that shows up when the actual map is lazy loaded
export const LocationsSkeleton = () => {
  return <div className="h-[400px] w-full flex-1 animate-pulse rounded" />;
};
